<div id="not-loggedin" class="container-fluid  main-container cirt-theme">
  <router-outlet name="master"></router-outlet>
</div>
